<template>
    <div class="page">
        <main>
            <list-item v-for="data in dataInfo"
                       :key="data.leaseID"
                       :data-info="data">
            </list-item>
        </main>

        <div class="list-none" v-if="getIsShowNone">
            <img src="../../../assets/list-none.png" alt="">
            <div>空荡荡的~暂无数据！</div>
        </div>

    </div>
</template>

<script>
    import ListItem from "./ListItem";
    import axios from "axios";
    import {Message} from 'element-ui';

    export default {
        name: "List",

        components: {
            ListItem
        },

        computed: {
            getIsShowNone() {
                return !(this.dataInfo && this.dataInfo.length > 0);
            }
        },

        data() {
            return {
                dataInfo: []
            }
        },

        created() {
             localStorage.setItem("token", this.$route.query.token || "");
            localStorage.setItem("orgID", this.$route.query.orgID || "");
            localStorage.setItem("type", this.$route.query.client || "");
            document.title = "租约管理"; 
            let url = axios.defaults.baseURL.replace('v1/org/','')
            axios({
                method: 'post',
                // url: "/api/v1/renter/leases/query",
                url:url+ "v1/users/leases/query",
                headers: {'Authorization': this.$route.query.token,'PYDDot-Client-Type':this.$route.query.client,'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)},
                data: {
                    state:'生效中',
                    pageIdx:0,
                    pageSize:100,
                }
            }).then(value => {
                if (value.data.data) {
                    this.dataInfo = value.data.data;
                }
                if (value.data.code !== 0) {
                    Message.error(value.data.message);
                }
            }).catch((err) => {
                Message.error(err.toString());
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    main {
        margin-bottom: 80px;
    }
</style>
